import { html, TemplateResult } from 'lit';
import { staticText } from '../../static-text';
import { stepIntro } from './partials/step-intro';

export function stepError(
	title = staticText.somethingHasGoneWrong,
	text = staticText.weAreSorryForThisInconvenience
): TemplateResult {
	return html`
		<div class="step">
			<div class="section theme-grey-light">
				<div class="wrapper">
					<div class="double-columns">
						<div class="double-columns__column">
							${stepIntro( title, `<p>${text}</p>` )}
						</div>
					</div>
				</div>
			</div>
		</div>
	`;
}
